export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-gray-400 pt-16 pb-8">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/9bc2178766357ca1f8e7030b470115cf/c42f4a326432be1cf9baf0d20e3986f8.png"
              alt="STORAD"
              className="h-12 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-sm leading-relaxed max-w-xs">
              店舗QRコードとアフィリエイトを融合したO2Oマーケティングプラットフォーム。
              全国2,400店舗以上に導入実績。
            </p>
            <div className="flex gap-3 mt-5">
              {['ri-twitter-x-line', 'ri-instagram-line', 'ri-facebook-circle-line', 'ri-youtube-line'].map((icon, i) => (
                <a key={i} href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center bg-gray-700 hover:bg-red-500 rounded-lg transition-colors cursor-pointer">
                  <i className={`${icon} text-sm text-white`}></i>
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5">
              <a href="#service">サービス</a>
            </h4>
            <ul className="flex flex-col gap-3 text-sm">
              {[
                { label: 'サービス概要', id: 'service' },
                { label: 'QRコード活用方法', id: 'qr-usage' },
                { label: 'アフィリエイト仕組み', id: 'affiliate' },
                { label: '導入事例', id: 'cases' },
                { label: '料金プラン', id: 'pricing' },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="cursor-pointer hover:text-white transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm mb-5">
              <a href="#contact">サポート</a>
            </h4>
            <ul className="flex flex-col gap-3 text-sm">
              {['よくある質問', 'お問い合わせ', 'プライバシーポリシー', '利用規約', '特定商取引法'].map((item) => (
                <li key={item}>
                  <a href="#" rel="nofollow" className="hover:text-white transition-colors">{item}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs">
          <p>&copy; 2024 STORAD Inc. All rights reserved.</p>
          <p>Store Affiliate Network</p>
        </div>
      </div>
    </footer>
  );
}
